<div class="container my-4">
    <div class="row">
      <div class="col-12 ">
        <span class="title_header_bar">Manage  Activity</span>
      </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="searchform">

      <div class="row d-flex mb-3 justify-content-start align-items-center flex-wrap grid-margin">
        <div class="col-md-4">
          <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
            <i class="fa fa-refresh"></i> Refresh
          </button> -->
          <app-button (refreshClicked)="clearFilter()"></app-button>

          <button type="button" class="btn excel_btn text-nowrap mr-2" (click)="exportAsXLSX()">
            <i class="fa fa-file-excel"></i> Export
          </button>
          <button type="button" class="btn btn-primary text-nowrap" (click)="gotoaddactivity(0)">
            <i class="fa fa-plus"></i> Add
          </button>
        </div>
        <div class="col-md-4 padd-right-file" style="display: flex;">
          <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
            <mat-label>Search</mat-label>
            <div class="search-input-container">
              <input formControlName="activityName" placeholder="Enter Activity Name" id="search" matInput
                type="text" #searchInput>
            </div>
          </mat-form-field>
          <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
            (click)="search()">
            <mat-icon style="color: white;">search</mat-icon>
          </button>
        </div>
      </div>
    </form>


      <div class="table-responsive mt-2 mb-4">
        <mat-table #table [dataSource]="dataSource" >

          <ng-container matColumnDef="ActivityName">
            <mat-header-cell *matHeaderCellDef >Activity Name</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign"> {{dataField.activityName}}</p>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="EmailRequired">
            <mat-header-cell *matHeaderCellDef >Email Required</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign"> {{dataField.isEmailRequired?'Yes':'No'}} </p>
            </mat-cell>
            </ng-container>
          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <div class="text-truncate text-center">
                <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-edit mr-3"
                (click)="gotoaddactivity(dataField.id)"></i>

                <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-trash-can"
                  (click)="deleteProduct(dataField.id)"></i>
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

          <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
          </mat-row>
        </mat-table>
      </div>